const fields = {
    default: ["first_name", "last_name", "email", "phone", "submit"],
    US: ["first_name", "last_name", "email", "phone", "usa_state", "submit", "privacy_policy_popup"],
    DK: ["first_name", "last_name", "email", "phone", "submit", "privacy_policy_link"]
};

export default fields;